import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import BusinessTaxAdvisoryHero from "@components/BusinessTaxAdvisoryPage/BusinessTaxAdvisoryHero";
import WhyAccount from "@components/BusinessTaxAdvisoryPage/WhyAccount";
import PullUpScheduler from "@components/PullUpScheduler/PullUpSchedulerV2";
import BusinessTaxAdvisoryPageStyles from "./BusinessTaxAdvisoryPageStyles";
import Row from "@components/EntityFormation/LandingPage/brownSectionRow";
import WhyAccountStyles from "@components/BusinessTaxAdvisoryPage/WhyAccountStyles";
import useMediaQuery from "@/helpers/hooks/useMediaQuery.js";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import FaqComponent from "@/components/Bookkeeping/FaqComponent";

const BusinessTaxAdvisoryPage = ({ data, setHideSchedulerHeader }) => {
  const {
    hero_sub_title,
    hero_title,
    background_models,
    cta_text,

    why_image,
    why_subtitle,
    why_title,

    bn_title,
    business_needs,

    about_services,

    common_content,

    testimonials,

    additional_questions,
    lead_values,
    paid_campaign,
    q_and_a: faqs,
    faq_title: faqTitle,
  } = data;

  const hero = {
    title: hero_title,
    subtitle: hero_sub_title,
    image: background_models[0].image,
    ctaText: cta_text,
  };

  const whyAccount = {
    why: {
      image: why_image,
      subtitle: why_subtitle,
      title: why_title,
    },

    businessNeeds: {
      title: bn_title,
      list: business_needs,
    },
  };
  const what_you_get = common_content.what_you_get;
  const get_started = common_content.get_started;
  const [isSchedulerOpen, setIsSchedulerOpen] = useState(false);
  const toggleIsSchedulerOpen = () => setIsSchedulerOpen(!isSchedulerOpen);
  const onScheduleAppointment = () => setIsSchedulerOpen(true);
  const isMobile = useMediaQuery("(max-width: 576px)");

  useEffect(() => {
    if (isSchedulerOpen) {
      setHideSchedulerHeader(true);
    } else {
      setHideSchedulerHeader(false);
    }
  }, [isSchedulerOpen]);

  return (
    <BusinessTaxAdvisoryPageStyles>
      <BusinessTaxAdvisoryHero
        data={hero}
        onCtaClicked={onScheduleAppointment}
      />
      <WhyAccount
        data={whyAccount}
        onCtaClicked={onScheduleAppointment}
        isMobile={isMobile}
      />
      <div className="why-accountant-section">
        <div className="container">
          {about_services.map((service, idx) => (
            <Row
              key={idx}
              service={service}
              idx={idx}
              isMobile={isMobile}
              isTaxAdvisoryPage={true}
              onCtaClicked={onScheduleAppointment}
            />
          ))}
        </div>
      </div>
      {/* What You Get Section */}
      <section className="what-you-get">
        <div className="container">
          <div className="row">
            <div className="col-md-12">{
              what_you_get?.title && (
                <h2>{what_you_get.title}</h2>
              )}
              <div className="row">
                <div className="cards-container">
                  {what_you_get.tiles.map((tile, index) => (
                    <div className="card" key={index}>
                      <img
                        src={tile.image}
                        alt="Tax Advisory"
                        width="500px"
                        height="500px"
                      />
                      <div className="title">
                        <h3>{tile.title}</h3>
                      </div>
                      <div className="card-body pb-0 px-0">
                        <p>{tile.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        {!isMobile && (
          <>
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="testimonials-container">
                    {testimonials.map((testimonial, index) => (
                      <div className="testimonial-section" key={index}>
                        <img
                          className="testimonial-image"
                          src={testimonial.image.url}
                          alt="Testimonial image"
                          width="500px"
                          height="500px"
                        />
                        <div className="testimonial-quote">
                          {testimonial.quote}
                        </div>
                        <div className="testimonial-title">
                          {testimonial.name}
                        </div>
                        <div className="stars">
                          <img
                            src="/static/images/icons/five-star-orange.png"
                            alt="Testimonial stars"
                            width="500px"
                            height="500px"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {isMobile && (
          <Carousel
            autoPlay={false}
            showArrows={false}
            showStatus={false}
            swipeable={true}
            showThumbs={false}
          >
            {testimonials.map((testimonial, index) => (
              <div className="testimonial-section" key={index}>
                <div className="testimonial-single">
                  <img
                    className="testimonial-image"
                    src={testimonial.image.url}
                    alt="Testimonial image"
                    width="500px"
                    height="500px"
                  />
                  <div className="testimonial-quote">{testimonial.quote}</div>
                  <div className="testimonial-title">{testimonial.name}</div>
                  <div className="stars">
                    <img
                      src="/static/images/icons/five-star-orange.png"
                      alt="Testimonial stars"
                      width="500px"
                      height="500px"
                    />
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        )}
        <div className="illustration">
          Actual customer testimonials. Photos are illustrative only.
        </div>
      </section>

      <section className="faq">
        <FaqComponent title={faqTitle} faqs={faqs} />
      </section>

      {/* Start now section */}
      <WhyAccountStyles>
        <div className="container custom-container scheduled-consultation">
          {!isMobile && (
            <div className="image-wrapper">
              <img
                src={get_started.image}
                alt="Get started image"
                width="500px"
                height="500px"
              />
            </div>
          )}

          <div className="consultation-text-container">
            <h2 className="consultation-title">{get_started.title}</h2>
            <p>{get_started.body_copy}</p>
            <button
              onClick={onScheduleAppointment}
              className="btn btn-secondary bottom-cta"
            >
              {get_started.button_text}
            </button>
          </div>
          {isMobile && (
            <div className="image-wrapper">
              <img
                src={get_started.image}
                alt="Get Started Illustrative Image"
                width="500px"
                height="500px"
              />
            </div>
          )}
        </div>
      </WhyAccountStyles>

      {isSchedulerOpen && (
        <PullUpScheduler
          setIsSchedulerOpen={toggleIsSchedulerOpen}
          AdditionalQuestions={additional_questions}
          leadValues={lead_values}
          PaidCampaign={paid_campaign}
        />
      )}
    </BusinessTaxAdvisoryPageStyles>
  );
};

BusinessTaxAdvisoryPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default BusinessTaxAdvisoryPage;
